
<div class="container-flex">

    <div class="sidebar">
        <ul class="nav flex-column nav-sidebar">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a class="nav-link" routerLink="/admin">Preferences</a></li>
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="/admin/lookup">Lookup</a></li>
        </ul>
    </div>



    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>


</div>
